import { compose } from 'recompose'
import { connect } from 'react-redux'
import { selectAddress } from '../../../../../../store/selectors/home'

const googleSunroofLink = ({ street, city, state, zip }) =>
  `https://www.google.com/get/sunroof#a=${encodeURIComponent([
    street,
    city,
    state,
    zip,
  ])}&b=80&f=buy&np=23&p=1`

const SolarPanelsContainer = compose(
  connect(state => ({
    googleSunroofLink: googleSunroofLink(selectAddress(state)),
  }))
)

export default SolarPanelsContainer
